var $3ab64b73ea27c23a$exports = {};
$3ab64b73ea27c23a$exports = {
    "Clear search": `Not\u{12B}r\u{12B}t mekl\u{113}\u{161}anu`
};


export {$3ab64b73ea27c23a$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
